import React, { FC, useCallback, useEffect } from 'react'
import { AddIcon, AvatarIcon, CheckedCircle, RemoveIcon } from '../../../icons'
import { AnalysisApi } from '../../../types/entities/analysis.types'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { addToCart, CartItemType, removeProduct } from '../../../features/cart/cartSlice'
import useTheme from '../../../hooks/useAppColor'
import { getProducts } from '../../../features/products/productSlice'

type AnalysisItemProps = {
    product: AnalysisApi,
    index: number,
    isInCart: boolean,
    clickHandle?: () => void
}
export const AnalysisItem: FC<AnalysisItemProps> = ({ product, index, isInCart, clickHandle }) => {
    const dispatch = useAppDispatch()
    const getTheme = useTheme()
    const cartItems = useAppSelector(state => state.cart.items)
    const categories = useAppSelector(state => state.categories.categories)
    const zabor = useAppSelector(state => state.categories.zabor)
    

    const addProduct = useCallback(() => {
        const category = categories.find(cat => cat.id === product.cat)
        dispatch(addToCart({ ...product as CartItemType }))

        if (category && category.take && category.take !== 0) {
            const alreadyInCart = cartItems.some(item => item.id === category.take)
            if (!alreadyInCart) {
                const analysis = zabor.find((a: any) => a.id === category.take)
                if (analysis) {
                    dispatch(addToCart({ ...analysis as CartItemType }))
                }
            }
        }
    }, [dispatch, product, categories, cartItems]);

    const removeItem = useCallback(() => {
        dispatch(removeProduct({id: product.id, cost: product.cost}))
    }, [dispatch, product]);

    useEffect(() => {
               localStorage.setItem('cartItems', JSON.stringify(cartItems))
            },[cartItems])

    return (
        <div onClick={clickHandle} key={product.id} className="analysis-item pd-10-0 border-bottom f-row-betw gap-15">
            <div className="f-column f-1">
                <p className={`${getTheme("c-dark", "c-lg")} fz-m fw-4`}>{product.name}</p>
                <p className={`${getTheme("c-dark", "c-white")} fz-m fw-7`}>{product.cost} ₽</p>
            </div>
            <div onClick={e => e.stopPropagation()}>
                <div onClick={!isInCart ? addProduct : removeItem} className="f-c-col">
                    {isInCart ? <RemoveIcon /> : <AddIcon />}
                </div>
            </div>

        </div>
    )
}
